import { render } from "./PanchangGraph.vue?vue&type=template&id=6728a91e&scoped=true"
import script from "./PanchangGraph.vue?vue&type=script&lang=js"
export * from "./PanchangGraph.vue?vue&type=script&lang=js"

import "./PanchangGraph.vue?vue&type=style&index=0&id=6728a91e&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6728a91e"]])

export default __exports__